import React from 'react';
import {Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {useAppointmentNotifications} from 'presentation/pages/private/hooks';
import {AppointmentsPastDueProps} from './types';

const {appointmentsNotifications} = translations['pt-br'].privateFlow.home;

export function AppointmentsPastDue({appointment}: AppointmentsPastDueProps) {
	const {formattedBeneficiary, isExam} = useAppointmentNotifications({
		appointment,
	});

	const part1 = `${formattedBeneficiary}, `;
	const highlighted = isExam
		? appointmentsNotifications.noShowExam
		: appointmentsNotifications.noShow;

	return (
		<Stack spacing={1}>
			<Typography>
				{part1}
				<Typography component="strong" fontWeight={700}>
					{highlighted}
				</Typography>
			</Typography>
		</Stack>
	);
}
